import { render, staticRenderFns } from "./CountdownFlip.vue?vue&type=template&id=1153126c&scoped=true&"
import script from "./CountdownFlip.vue?vue&type=script&lang=ts&"
export * from "./CountdownFlip.vue?vue&type=script&lang=ts&"
import style0 from "./CountdownFlip.vue?vue&type=style&index=0&id=1153126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1153126c",
  null
  
)

export default component.exports